angular
  .module('account.edit-video', [
    'common.header',
    'common.footer',
    'config',
    'directives.contenteditable',
    'account.settings.social',
    'security.service',
    'security.authorization',
    'services.accountResource',
    'services.utility',
    'services.formErrors',
    'ui.bootstrap',
    'directives.serverError',
    'ngTagsInput',
    'ngFileUpload',
    'toggle-switch',
    'angular-growl',
    'ckeditor',
    'resources.User',
    'resources.Tag',
    'resources.Category',
    'resources.Article',
    'resources.AdminUser',
    'filters.rawHtml',
    'ckeditorPlaceholder'
  ])

  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('account.edit-video', {
      url: '/edit-video/:id',
      title: 'Edit Article',
      views: {
        'main@': {
          template: require('./edit-video.tpl.html'),
          controller: 'EditVideoCtrl',
          resolve: {
            locations: ["adminResource", function (adminResource) {
              return adminResource.searchTags({ type: 'location' });
            }],
            playersAndTeams: ["adminResource", function (adminResource) {
              return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
            }],
            listOfUsers: ["AdminUser", function (AdminUser) {
              return AdminUser.getAll().$promise.then(function (result) {
                return result.data;
              });
            }]
          }
        }
      }
    });
  }])

  .controller('EditVideoCtrl', ["$scope", "$location", "$log", "$interval", "$stateParams", "$sce", "$uibModal", "security", "utility", "growl", "user", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "VIDEO_TYPES", "APP_IMG_URLS", "HOST_URL", "Upload", "formErrors", "dateFilter", "Article", "Category", "User", "Tag", "socket", "$window", "locations", "playersAndTeams", "listOfUsers", "adminResource", function (
    $scope,
    $location,
    $log,
    $interval,
    $stateParams,
    $sce,
    $uibModal,
    security,
    utility,
    growl,
    user,
    SOCIAL,
    STATUSES,
    ARTICLE_STYLES,
    VIDEO_TYPES,
    APP_IMG_URLS,
    HOST_URL,
    Upload,
    formErrors,
    dateFilter,
    Article,
    Category,
    User,
    Tag,
    socket,
    $window,
    locations,
    playersAndTeams,
    listOfUsers,
    adminResource
  ) {
    $scope.dataLoaded = false;
    $scope.imgUrl = APP_IMG_URLS['base'];
    $scope.nameLocation = '';

    var urlGenerated = false;
    var timer = null;
    var slugify = require('../../utils/slugify');

    var toFormatArticleDate = require('../rgr-utils').toFormatArticleDate;
    var prepareBeforeEmitArticleChanged = require('../rgr-utils').prepareBeforeEmitArticleChanged;
    var prepareForEditArticle = require('../rgr-utils').prepareForEditArticle;
    var isProgram = user && user.account && user.account.is_program ? true : false;
    $scope.stadiumsList = !!locations
      ? locations.data.map(function (p) {
          return { _id: p._id, name: p.name };
        })
      : [];

    $scope.playersAndTeamsList = !!playersAndTeams
      ? playersAndTeams.data.map(function (p) {
          return {
            _id: p._id,
            name: p.name,
            type: p.role.role_type
          };
        })
      : [];

    $scope.profilesList = $scope.playersAndTeamsList.length
      ? $scope.playersAndTeamsList.filter(function (e) {
          return e.type === 'profile';
        })
      : [];
    $scope.editPermit = false;

    var publishDate = moment();
    var init = function (article, categories) {
      // console.log( '>>> init', article.publish_date, article.status, [1, 3, 17, 18].indexOf(article.status) );
      if (article.status) {
        if ([1, 3, 17, 18].indexOf(article.status) >= 0) {
          publishDate = moment(article.publish_date);
        }
      }

      $scope.categories = categories;
      $scope.statuses = _.filter(STATUSES, function (status) {
        return ~user.permissions.statuses.indexOf(status.id);
      });
      if (user.permissions.statuses[0] === '*') {
        $scope.statuses = STATUSES;
      }

      $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
        $scope.howToShow = newVal.value.replace(/ /g, '');
        $scope.data.type = newVal.type;
      });

      $scope.$watch('data.locationInfo', function (newVal, oldVal) {
        if (newVal && newVal.lat && newVal.lon) {
          $scope.nameLocation = newVal.formatted_address;
        }
      });

      $scope.isAdmin = false;
      if (user.permissions.is_admin) {
        $scope.isAdmin = true;
        // console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
      }
      $scope.data = {
        _id: article._id,
        article_id: article.article_id,
        title: _.unescape(article.title),
        sefriendly: article.sefriendly,
        status: _.find(STATUSES, { id: '' + article.status }),
        orderNumber: article.orderNumber,
        image: article.image,
        video: article.video,
        mediaCloud_id: article.mediaCloud_id,
        media_id: article.media_id,
        arrThumbs: article.arrThumbs || [],
        readyToStream: article.readyToStream,
        duration: article.duration,
        video_type: isProgram ? 'program' : 'video',
        type: 'video',
        location: article.location && article.location,
        locationInfo: article.locationInfo && article.locationInfo,
        image_caption: _.unescape(article.image_caption),
        body: _.unescape(article.body),
        abstract: _.unescape(article.abstract),

        equipo_local: article.equipo_local_new
          ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local_new._id })
          : article.equipo_local
          ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local })
          : undefined,

        equipo_visitante: article.equipo_visitante_new
          ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante_new._id })
          : article.equipo_visitante
          ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante })
          : undefined,

        goals: article.goals,
        goles_local: article.goles_local,
        goles_visitante: article.goles_visitante,

        referee: article.referee_new
          ? _.find($scope.profilesList, { _id: article.referee_new._id })
          : !!article.referee
          ? _.find($scope.profilesList, { _id: article.referee })
          : undefined,

        incidents: article.incidents,
        show_inarticle: _.find(ARTICLE_STYLES, { id: '' + article.show_inarticle }),
        category: article.category ? _.find(categories, { id: article.category.id }) : '',
        tags: [],
        author: article.author,
        last_edited_by: article.last_edited_by,
        published_by: article.published_by,
        publish_date: toFormatArticleDate(publishDate),
        team1: article.team1,
        team2: article.team2,
        team1players: angular.isArray(article.team1players)
          ? article.team1players.map(function (e) {
              return Object.assign(e, { text: e.name });
            })
          : [],
        team2players: angular.isArray(article.team2players)
          ? article.team2players.map(function (e) {
              return Object.assign(e, { text: e.name });
            })
          : [],
        created_at: article.created_at,

        stadium: article.stadium_new
          ? _.find($scope.stadiumsList, { _id: article.stadium_new._id })
          : !!article.stadium
          ? _.find($scope.stadiumsList, { _id: article.stadium })
          : undefined
      };

      if ($scope.data && (!$scope.data.arrThumbs || ($scope.data.arrThumbs && !$scope.data.arrThumbs.length))) {
        if ($scope.data.readyToStream && $scope.data.duration && $scope.data.duration > 0) {
          do {
            var num = Math.floor(Math.random() * Math.floor($scope.data.duration - 0.5));
            if ($scope.durations.indexOf(num) < 0) {
              $scope.data.arrThumbs.push($scope.createThumb($scope.data.mediaCloud_id) + '?time=' + num + 's');
              $scope.durations.push(num);
            }
          } while ($scope.durations.length < 3);
          $scope.thumbnail = $scope.createThumb($scope.data.mediaCloud_id);
          $scope.data.image = $scope.durations.length
            ? $scope.createThumb($scope.data.mediaCloud_id) + '?time=' + $scope.durations[0] + 's'
            : $scope.createThumb($scope.data.mediaCloud_id) + '?time=0s';
        }
      }

      $scope.start_at = 0;
      $scope.iframe =
        '<iframe src="' +
        HOST_URL +
        $scope.data.article_id +
        '/iframe"' +
        ' height="338" width="600" allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>';
      $scope.changeStartAt = function (value) {
        if (value !== null && value > -1) {
          $scope.iframe =
            '<iframe src="' +
            HOST_URL +
            $scope.data.article_id +
            '/iframe?start=' +
            value +
            '"' +
            ' height="338" width="600" allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>';
        }
      };
      // ==search place google==
      var input = document.getElementById('pac-input');
      var searchBox = new window.google.maps.places.Autocomplete(input);
      searchBox.addListener('place_changed', function () {
        var place = searchBox.getPlace();
        if (!place.geometry) {
          growl.error('Can not get location');
          input.value = $scope.nameLocation;
          return;
        }
        var lat = place.geometry.location.lat();
        var lon = place.geometry.location.lng();
        $scope.data.location = { lat: lat, lon: lon };
        $scope.data.locationInfo = {
          lat: lat,
          lon: lon,
          geometry: place.geometry,
          name: place.name,
          id: place.id,
          icon: place.icon,
          formatted_address: place.formatted_address,
          place_id: place.place_id,
          types: place.types,
          url: place.url,
          vicinity: place.vicinity
        };
      });
      // ==search place google==

      $scope.thumbnail = $scope.data.type === 'video' ? article.image : APP_IMG_URLS.base + article.image;

      $scope.videoUrl = article.video;

      $scope.changePT1(article.equipo_local);
      $scope.changePT2(article.equipo_visitante);

      $scope.listOfUsers = {
        username: article.author.username,
        options: listOfUsers
          .filter(function (p) {
            return p.account.groups && p.account.groups.length > 0;
          })
          .map(function (u) {
            var full = u.account.name.full;
            if (!full) {
              full = u.account.name.first + ' ' + u.account.name.last;
            }
            if (full === ' ') full = u.username;
            return {
              username: u.username,
              picture: u.account.picture,
              name: full || u.username
            };
          })
      };

      var listenerFunction = null;
      //send user name of person who start editing and  id of edited topic
      socket.emit('connectDocs', {
        userName: user.account.name.full,
        artId: article.article_id,
        userId: user._id,
        docs: $scope.data
      });
      var internalChange = false;
      var listenData = false;

      socket.on('startEditing', function (data) {
        // console.log( '>>> startEditing', data );
        $scope.editPermit = true;
        $scope.editing = 'Editing by: ' + user.account.name.full;
        if (data) {
          $scope.data = prepareForEditArticle(data.data);
        }
        listenerFunction = $scope.$watchCollection(
          'data',
          _.debounce(function (newValue, oldValue) {
            if (!_.isEqual(newValue, oldValue) && !internalChange) {
              // console.log('emit articleChanged', article.article_id, prepareBeforeEmitArticleChanged(newValue));
              socket.emit('articleChanged', {
                artId: article.article_id,
                data: prepareBeforeEmitArticleChanged(newValue)
              });
            }
            internalChange = false;
          }, 1000)
        );
        listenData = true;
      });

      socket.on('startWatching', function (articleRoom) {
        $scope.data = articleRoom.docs;
        var user = _.find(articleRoom.users, function (user) {
          return user.userId === articleRoom.editing;
        });
        $scope.editing = 'editing by: ' + user.name;
      });

      socket.on('newcomer', function (watchers) {
        $scope.watching = watchers.reduce(function (prev, obj) {
          return prev + obj.name + ', ';
        }, 'watching by: ');
      });

      //send user name of person who ends editing and  id of edited topic
      $scope.$on('$locationChangeStart', function (event) {
        if ($scope.editPermit) {
          socket.emit('endEdit');
          socket.off('applyChanges');
        }
      });

      var windowElement = angular.element($window);
      windowElement.on('beforeunload', function (event) {
        // do whatever you want in here before the page unloads.
        if ($scope.editPermit) {
          socket.emit('endEdit');
          socket.off('applyChanges');
        }
        // the following line of code will prevent reload or navigating away.
        event.preventDefault();
      });

      //recieving changes from other editors
      socket.on('applyChanges', function (data) {
        // console.log( '>>> on applyChanges', data );
        if (data.editing === user._id) {
          $scope.editPermit = true;
          if (!listenerFunction) {
            listenerFunction = $scope.$watchCollection(
              'data',
              _.debounce(function (newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue) && !internalChange) {
                  console.log('emit articleChanged');
                  socket.emit('articleChanged', {
                    artId: article.article_id,
                    data: prepareBeforeEmitArticleChanged(newValue)
                  });
                }
                internalChange = false;
              }, 1000)
            );
          }
        } else {
          $scope.editPermit = false;
          if (listenerFunction) {
            listenerFunction();
            listenerFunction = null;
          }
        }
        const users = data.users;

        const editor = _.find(users, function (us) {
          return us.userId === data.editing;
        });
        const watchers = users.filter(function (us) {
          return us.userId !== data.editing;
        });
        $scope.editing = 'editing by: ' + editor.name;
        if (watchers.length > 0) {
          $scope.watching = watchers.reduce(function (prev, obj) {
            return prev + obj.name + ', ';
          }, 'watching by: ');
        } else {
          $scope.watching = '';
        }

        if (!_.isEqual($scope.data, data.docs)) {
          $scope.data = prepareForEditArticle(data.docs);
          internalChange = true;
        }
      });

      $scope.switch = function () {
        socket.emit('changeEditPermit', {
          artId: article.article_id,
          userId: user._id
        });
      };

      if (article.tags) {
        $scope.data.tags = article.tags.map(function (tag) {
          return {
            _id: tag._id,
            text: tag.name,
            sefriendly: slugify(tag.name),
            avatar: tag.avatar || ''
          };
        });
      }

      if ($scope.data.status === undefined) {
        $scope.data.status = {
          id: '0',
          value: localizedMessages.get('pending')
        };
      }

      $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
        $scope.data.show_inarticle = _.find(ARTICLE_STYLES, { id: '' + newVal.id });
      });
      $scope.dataLoaded = true;
    };

    $scope.article_styles = ARTICLE_STYLES;
    $scope.video_types = VIDEO_TYPES;
    $scope.uploading = false;
    $scope.completed = false;
    $scope.durations = [];
    $scope.progressPercentage = 0;
    $scope.isSaving = false;
    $scope.autosaveTimer = 180;
    $scope.accordion = {
      score: true,
      publishing_date: true,
      url: true,
      image: true,
      published_by: false
    };

    var startTimer = function () {
      return $interval(function () {
        if ($scope.autosaveTimer <= 0) {
          $scope.save();
        }
        $scope.autosaveTimer -= 1;
      }, 1000);
    };

    var resetTimer = function () {
      $scope.autosaveTimer = 180;
      $interval.cancel(timer);
    };

    $scope.autosaveChanged = function () {
      if ($scope.autosave) {
        timer = startTimer();
      } else {
        resetTimer();
      }
    };

    $scope.canChangeAuthor = function () {
      return user.permissions.is_editor && $scope.canChangeCategory();
    };

    $scope.canChangeStatus = function () {
      if (user.permissions.is_admin) return true;
      return true;
      //return ~user.permissions.statuses.indexOf(article.status + '');
    };

    $scope.canChangeCategory = function () {
      if (user.permissions.is_admin) return true;
      return true;
      //return ~user.permissions.categories.indexOf(article.category.id);
    };

    $scope.canChangeFormat = function () {
      return true;
    };

    $scope.titleChanged = function () {
      $scope.data.title = $scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' ');
      if ($scope.data.sefriendly) {
        return;
      }
      $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' '));
    };

    $scope.saveBtnText = 'Save';
    $scope.switchBtnText = 'Switch';

    $scope.onReady = function () {
      CKEDITOR.on('dialogDefinition', function (ev) {
        // Take the dialog name and its definition from the event data

        var dialogName = ev.data.name;
        var dialogDefinition = ev.data.definition;
        if (dialogName == 'image2' || dialogName == 'link') {
          // Remove upload tab
          dialogDefinition.removeContents('Upload');
          dialogDefinition.removeContents('upload');
        }
      });
    };

    $scope.save = function () {
      if ($scope.uploading) {
        growl.error('Please wait for the upload process to complete');
        return;
      }
      resetTimer();
      $scope.autosaveChanged();
      $scope.data.sefriendly = slugify($scope.data.sefriendly);

      if (!$scope.data.video) {
        growl.error('Video is required');
        return;
      }
      if (!$scope.data.title) {
        growl.error('Title is required');
        return;
      }
      if (!$scope.data.category) {
        growl.error('Category is required');
        return;
      }
      // if (!$scope.data.body) {
      //   growl.error('Body is required');
      //   return;
      // }

      $scope.isSaving = true;

      var data = angular.copy($scope.data);
      data.edition = data.category.path.split('/')[1];
      data.type = data.show_inarticle.type;
      // data.video_type = data.video_type.value;
      data.show_inarticle = parseInt(data.show_inarticle.id, null);
      data.status = parseInt(data.status.id, null);
      // data.categories = data.category.path.split('/').filter(Boolean).map(function(item) {return {sefriendly: item};}).reverse();
      // delete data['category'];
      data.category = {
        id: data.category.id,
        name: data.category.name,
        sefriendly: data.category.sefriendly,
        parent: data.category.parent,
        parent_id: data.category.parent_id
      };

      data.tags = data.tags || [];
      data.tags = data.tags.map(function (tag) {
        return {
          name: tag.text,
          sefriendly: slugify(tag.text),
          avatar: tag.avatar || ''
        };
      });

      data.publish_date = (data.publish_date ? moment(data.publish_date) : publishDate).toISOString();

      if (!$scope.canChangeAuthor()) {
        data.last_edited_by = {
          name: user.account.name.full,
          username: user.username
        };
      }

      if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
        data.published_by = {
          name: user.account.name.full,
          username: user.username
        };
      }

      var catArray = data.category.parent == '/' ? [] : data.category.parent.substring(1).split('/');
      var pDate = new Date(data.created_at);
      var pMonth = pDate.getUTCMonth() + 1;
      var dateSeg =
        '/' +
        pDate.getUTCFullYear() +
        '/' +
        ('0' + pMonth).slice(-2) +
        '/' +
        ('0' + pDate.getUTCDate()).slice(-2) +
        '/';
      data.url_segment = dateSeg;
      if (catArray.length == 0) {
        data.url_segment = '/' + data.category.sefriendly + dateSeg;
      } else if (catArray.length == 1) {
        data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
      } else if (catArray.length > 1) {
        data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
      }

      data.abstract = CKEDITOR.instances.editor.getData();

      // console.log("$startDate------->>>>>>>" + data.startDate);

      Article.update(
        data,
        function (result) {
          setTimeout(function () {
            //growl.info('Changes saved!');
            $scope.data.last_edited_by = data.last_edited_by;
          }, 1000);
        },
        formErrors.growlErrors
      ).$promise.then(function (resp) {
        // $scope.data = resp;
        $scope.saveBtnText = 'Saved!';
        $scope.isSaving = false;
        setTimeout(function () {
          $scope.saveBtnText = 'Saved!';
        }, 500);
      });
    };

    $scope.onChangeVideoUrl = function () {
      $scope.videoUrl = $scope.data.video;
    };

    $scope.notify = function () {
      var data = angular.copy($scope.data);
      data.edition = data.category.path.split('/')[1];
      data.show_inarticle = parseInt(data.show_inarticle.id, null);
      data.status = parseInt(data.status.id, null);
      data.category = {
        id: data.category.id,
        name: data.category.name,
        sefriendly: data.category.sefriendly,
        parent: data.category.parent,
        parent_id: data.category.parent_id
      };

      data.tags = data.tags || [];
      data.tags = data.tags.map(function (tag) {
        return {
          name: tag.text,
          sefriendly: slugify(tag.text),
          avatar: tag.avatar || ''
        };
      });

      // console.log( '>>> notify', dateValue, data.publish_date );
      if (dateValue) {
        data.publish_date = moment(dateValue).toISOString();
      } else {
        data.publish_date = publishDate.toISOString();
      }

      if (!$scope.canChangeAuthor()) {
        data.last_edited_by = {
          name: user.account.name.full,
          username: user.username
        };
      }

      if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
        data.notify = 1;
        //console.log($scope.data.title);
        Article.update(
          data,
          function (result) {
            setTimeout(function () {
              //growl.info('Changes saved!');
              $scope.data.last_edited_by = data.last_edited_by;
              // $location.path('/edit-article/' + result.data._id);
            }, 1000);
          },
          formErrors.growlErrors
        ).$promise.then(function () {
          $scope.saveBtnText = 'Saved!';
          $scope.isSaving = false;
          setTimeout(function () {
            $scope.saveBtnText = 'Saved!';
          }, 500);
        });
      }
    };
    $scope.$on('$locationChangeStart', function (event, next, current) {
      if (!$scope.isSaving) {
        var answer = confirm('Are you sure you want to navigate away from this page');
        if (!answer) {
          event.preventDefault();
        }
      }
    });

    $scope.$watch('file', function (file) {
      if (!file) return;
      $scope.upload(file);
    });

    $scope.createThumb = function (id) {
      return 'https://cloudflarestream.com/' + id + '/thumbnails/thumbnail.jpg';
    };

    $scope.selectThumb = function (thumb) {
      $scope.data.image = thumb;
    };

    $scope.canGetInfo = true;

    $scope.getInfoVideo = function () {
      if ($scope.canGetInfo) {
        Article.query({ id: $stateParams.id }).$promise.then(function (result) {
          console.log(result);
          if (!result.readyToStream) {
            return growl.error('Inprogress');
          }
          $scope.data.arrThumbs = result.arrThumbs;
          $scope.data.readyToStream = result.readyToStream;
          $scope.thumbnail = $scope.createThumb(result.mediaCloud_id);
          $scope.data.duration = result.duration;
          $scope.data.image = result.image;
        });
        // Article.getInfoVideo({ mediaId: $scope.data.mediaCloud_id }).$promise.then(function(data) {
        //   if (data && data.readyToStream && data.duration && data.duration > 0) {
        //     do {
        //       var num = Math.floor(Math.random() * Math.floor(data.duration - 0.5));
        //       if ($scope.durations.indexOf(num) < 0) {
        //         $scope.data.arrThumbs.push($scope.createThumb(data.uid) + '?time=' + num + 's');
        //         $scope.durations.push(num);
        //       }
        //     } while ($scope.durations.length < 3);
        //     $scope.data.readyToStream = data.readyToStream;
        //     $scope.thumbnail = $scope.createThumb(data.uid);
        //     $scope.data.image = $scope.durations.length
        //       ? $scope.createThumb(data.uid) + '?time=' + $scope.durations[0] + 's'
        //       : $scope.createThumb(data.uid) + '?time=0s';
        //     $scope.data.duration = data.duration;
        //   } else {
        //     growl.error('Inprogress');
        //   }
        // });
        $scope.canGetInfo = false;
        window.setTimeout(function () {
          $scope.canGetInfo = true;
        }, 10000);
      }
    };

    // upload on file select or drop
    $scope.upload = function (file) {
      $scope.uploading = true;
      $scope.durations = [];
      $scope.progressPercentage = 0;
      $scope.data.image = '';
      $scope.data.arrThumbs = [];

      // return;
      Upload.upload({
        url: $scope.data.show_inarticle.type === 'video' ? '/api/media/upload-video' : '/api/articles/upload',
        data: { file: file, videoId: $stateParams.id }
      }).then(
        function (resp) {
          if (resp.data.duration && resp.data.duration > 0 && resp.data.readyToStream) {
            do {
              var num = Math.floor(Math.random() * Math.floor(resp.data.duration - 0.5));
              if ($scope.durations.indexOf(num) < 0) {
                $scope.data.arrThumbs.push($scope.createThumb(resp.data.mediaCloudId) + '?time=' + num + 's');
                $scope.durations.push(num);
              }
            } while ($scope.durations.length < 3);
          }

          window.setTimeout(function () {
            $scope.data.readyToStream = resp.data.readyToStream;
            $scope.thumbnail = $scope.createThumb(resp.data.mediaCloudId);
            $scope.data.image = $scope.durations.length
              ? $scope.createThumb(resp.data.mediaCloudId) + '?time=' + $scope.durations[0] + 's'
              : $scope.createThumb(resp.data.mediaCloudId) + '?time=0s';
            $scope.data.video = resp.data.preview;
            $scope.data.duration = resp.data.duration;
            $scope.uploading = false;
            $scope.completed = true;
          }, 500);
          $scope.data.media_id = resp.data._id;
          $scope.data.mediaCloud_id = resp.data.mediaCloudId;
          growl.info('Uploaded successfully!.');
        },
        function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = null;
          console.log('Error status: ' + resp.status);
        },
        function (evt) {
          var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
          $scope.progressPercentage = progressPercentage;
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        }
      );
    };

    $scope.loadTags = function (query) {
      return Tag.search({ q: query }).$promise.then(function (tags) {
        if (!tags) return [];
        return tags.map(function (tag) {
          return {
            _id: tag._id,
            text: tag.nametag,
            name: tag.nametag,
            oficial: tag.oficial,
            sefriendly: tag.name,
            avatar: tag.avatar || ''
          };
        });
      });
    };

    $scope.delete = function (tag) {
      if (!confirm('Are you sure you want to delete this article?')) {
        return;
      }
      Article.delete(
        { id: tag._id },
        function (result) {
          setTimeout(function () {
            growl.info('Article removed!');
            $location.path('/account/my-articles');
          }, 1000);
        },
        formErrors.growlErrors
      );
    };

    async.parallel(
      {
        article: function (cb) {
          Article.query({ id: $stateParams.id }).$promise.then(function (result) {
            return cb(null, result);
          });
        },
        categories: function (cb) {
          var options = [];
          var generateCategoryOptions = function (items, container) {
            items.forEach(function (item) {
              if (!item.path) {
                return;
              }
              var depth = item.path.split('/').filter(Boolean).length;
              var indent = new Array(5).join(String.fromCharCode(160));
              container.push({
                id: item.id,
                path: item.path,
                sefriendly: item.sefriendly,
                parent: item.parent,
                parent_id: item.parent_id,
                name: item.name,
                _name: new Array(depth).join(indent) + item.name
              });
              if (item.children) {
                generateCategoryOptions(item.children, container);
              }
            });
            return container;
          };
          Category.getPermittedTree({ type: 'video' }).$promise.then(function (data) {
            generateCategoryOptions(data, options);
            cb(null, options);
          });
        }
      },
      function (err, results) {
        if (err) return console.log(err);
        if (results.article.error) {
          $location.path('/unauthorized');
        } else {
          if (results.article.show_inarticle != 21 && results.article.show_inarticle != 22) {
            init(results.article, results.categories);
          } else {
            $scope.isSaving = true;
            $location.path('/account/edit-article-live/' + results.article.article_id);
          }
        }
      }
    );

    $scope.changePT1 = function (pt1) {
      var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
        return e._id === pt1;
      });
      // console.log( '>>>1', playerOrTeam );
      if (playerOrTeam.length) {
        $scope.data.equipo_local_name = playerOrTeam[0].name;
      }
    };

    $scope.changePT2 = function (pt2) {
      var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
        return e._id === pt2;
      });
      // console.log( '>>>2', playerOrTeam );
      if (playerOrTeam.length) {
        $scope.data.equipo_visitante_name = playerOrTeam[0].name;
      }
    };

    $scope.loadProfiles = function (query) {
      return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
        if (!profiles) return [];
        var searchName = query.toLowerCase();
        return profiles.data
          .filter(function (p) {
            var name = p.name.toLowerCase();
            return name.indexOf(searchName) > -1;
          })
          .map(function (p) {
            return {
              _id: p._id,
              name: p.name
            };
          });
      });
    };

    $scope.changedAuthor = function () {
      var username = $scope.listOfUsers.username;
      $scope.data.author = $scope.listOfUsers.options.find(function (u) {
        return u.username === username;
      });
    }; // changeAuthor
  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/edit-video/edit-video.js